import { NestedRadioGroupProps, toExtendedOption } from "@hightouch/formkit";
import { SharedProps } from ".";
import { Controller, useFormContext } from "react-hook-form";
import {
  NestedRadioGroup,
  useMissingFormkitRelationships,
} from "src/formkit/components";
import { useMemo } from "react";

export const FKNestedRadioGroup = ({
  name,
  rootKey,
  listKey,
  options,
  query,
  isDisabled,
}: NestedRadioGroupProps & { listKey: string } & SharedProps) => {
  const { getValues, setValue } = useFormContext();

  useMissingFormkitRelationships(
    name,
    useMemo(
      () => (rootKey ? [listKey, rootKey] : [listKey]),
      [listKey, rootKey],
    ),
  );

  return (
    <Controller
      name={name}
      render={({ field }) => (
        <NestedRadioGroup
          loading={query.isFetching}
          isDisabled={isDisabled}
          options={toExtendedOption(query.enabled ? query.data : options)}
          reload={query.refetch}
          value={getValues(listKey)}
          onChange={(value: string[]) => {
            field.onChange(value[value.length - 1]);
            setValue(listKey, value);
            if (rootKey) {
              setValue(rootKey, value[0]);
            }
          }}
        />
      )}
    />
  );
};
